{
    "moovyVirtualKeyboard.button.redeemPermit": "Lunasta lupa",
    "page.qrcode.welcome": "Tervetuloa!",
    "page.device.login.button": "Kirjaudu sisään",
    "page.device.textfield.login.username": "Käyttäjätunnus",
    "page.device.textfield.login.password": "Salasana",
    "page.homePage.instructions.parkingInfo.organization": "{permitDuration}h pysäköintilupa",
    "page.homePage.instructions.parkingInfo.default": "Pysäköintilupa",
    "page.homePage.instructions.visitorMessage.default": "Pysäköintilupa on voimassa syöttämiesi tietojen mukaan.",
    "page.homePage.select.product": "Valitse pysäköintilupa",
    "page.homePage.instructions.enterRegisterNumber": "SYÖTÄ REKISTERITUNNUS: ",
    "page.homePage.instructions.registerNumber.arialabel": "Rekisteritunnus",
    "page.homePage.instructions.visitorMessage.organization.arialabel": "Yritys",
    "page.homePage.toast.permitGranted": "Pysäköintilupa myönnetty.",
    "page.homePage.toast.errorCreatingPermit": "Pysäköintilupaa ei myönnetty.",
    "page.homePage.toast.errorCreatingPermit.localizedErrorMessage": "Pysäköintilupaa ei myönnetty: {message}",
    "page.homePage.success.grantedSuccessfully": "Pysäköintilupa on myönnetty onnistuneesti rekisteritunnukselle",
    "page.homePage.success.permitType": "Pysäköintilupa",
    "page.homePage.success.permitTime": "Ajankohta",
    "page.homePage.success.licensePlate": "Rekisteritunnus",
    "page.homePage.success.okButton": "Valmis",
    "page.homePage.success.clearingPage": "Tämä sivu tyhjennetään 10 sekunnin päästä.",
    "page.homePage.configurationError.title": "Pysäköintilupa",
    "page.homePage.configurationError.body": "Lupien myöntäminen ei valitettavasti ole mahdollista. Ota yhteyttä henkilökuntaan.",
    "page.homePage.configurationError.alert": "Asennustietoja ei voitu ladata",
    "page.homePage.configurationError.button": "Lataa tiedot uudelleen",
    "page.passcodePrompt.header": "Syötä tunnussana",
    "page.passcodePrompt.label": "Tunnussana",
    "page.passcodePrompt.submit": "Tallenna",
    "page.passcodePrompt.configurationFetch.error": "Konfiguraation haku ei onnistunut",
    "page.passcodePrompt.configurationFetch.error.401": "Tunnussana väärin",
    "page.passcodePrompt.configurationFetch.success": "Konfiguraatio ladattiin onnistuneesti",
    "page.passcodePrompt.configurationFetch.reload": "Jatka",
    "language.finnish": "Suomeksi",
    "language.english": "In English",
    "api.error.code.generic": "Tapahtui virhe",
    "moovyErrorPage.oops": "Hups!",
    "moovyErrorPage.message": "Pahoittelut, sivua ei voi ladata. Tarkista osoite ja yritä ladata sivu uudestaan.",
    "common.actions.error": "Tapahtui virhe",
    "common.actions.get.error": "Tietojen haku epäonnistui",
    "common.actions.network.error.message": "Lataus epäonnistui. Lupaa ei myönnetty.",
    "common.network.offline": "Ei Internet-yhteyttä. Tarkista verkko, jotta voit jatkaa palvelun käyttöä."
}